<template>
  <div v-if="pageFooterConfig.show !== false" class="x-page-footer" :class="[realSize ? 'x-page-footer--' + realSize : '']" @dblclick="handleDblclick">
    <template v-for="(item, index) in pageFooterConfig.list">
      <span class="x-page-footer-label" :key="item.label">{{item.label}}{{pageFooterConfig.separator}}</span>
      <template v-for="valueItem in item.values">
        <span class="x-page-footer-value" :key="valueItem + index">{{valueItem}}</span>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'XPageFooter',
  inheritAttrs: false,
  inject: {
    $admin: {
      default: null
    }
  },
  props: {
    size: String,
    pageFooterConfig: {
      type: Object,
      default() {
        return {
          show: true,
          separator: ':',
          list: [
            // {
            //   label: '分号前面的内容',
            //   values: []分号后的文字数组
            // }
          ]
        };
      }
    }
  },
  methods: {
    handleDblclick(e) {
      this.$emit('dblclick', e);
    }
  },
  computed: {
    realSize() {
      if (this.size) {
        return this.size;
      }
      if (!this.$admin || this.$admin.sizes === false) {
        return '';
      }
      if (this.$admin.defaultSize === 'tiny') {
        return 'mini';
      }
      return '';
    }
  }
};
</script>
<style lang="scss">
.x-page-footer {
  box-sizing: content-box;
  cursor: pointer;
  display: inline-block;
  padding: 2px 0;
  line-height: 28px;
  height: 28px;
  vertical-align: top;
  font-size: 13px;
  .x-page-footer-label {
    padding-left: 10px;
    &:first-of-type {
      padding-left: 0px;
    }
  }
  .x-page-footer-value {
    padding-left: 5px;
  }
}

.x-page-footer--mini {
  height: 22px;
  line-height: 22px;
  font-size: 13px;
}
</style>